
export const restaurantList =[
    {
        "card": {
        "card": {
        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
        "layout": {
        "columns": 4
        },
        "id": "restaurant_grid_listing",
        "gridElements": {
        "infoWithStyle": {
        "@type": "type.googleapis.com/swiggy.presentation.food.v2.FavouriteRestaurantInfoWithStyle",
        "restaurants": [
        {
        "info": {
        "id": "10576",
        "name": "Pizza Hut",
        "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/7/16/87e56c63-b521-4257-96ae-a42229b92009_10576.jpg",
        "locality": "6th Block",
        "areaName": "Koramangala",
        "costForTwo": "₹350 for two",
        "cuisines": [
        "Pizzas"
        ],
        "avgRating": 4.2,
        "parentId": "721",
        "avgRatingString": "4.2",
        "totalRatingsString": "21K+",
        "sla": {
        "deliveryTime": 36,
        "lastMileTravel": 0.7,
        "serviceability": "SERVICEABLE",
        "slaString": "35-40 mins",
        "lastMileTravelString": "0.7 km",
        "iconType": "ICON_TYPE_EMPTY"
        },
        "availability": {
        "nextCloseTime": "2025-01-29 04:00:00",
        "opened": true
        },
        "badges": {},
        "isOpen": true,
        "aggregatedDiscountInfoV2": {},
        "type": "F",
        "badgesV2": {
        "entityBadges": {
        "imageBased": {},
        "textBased": {},
        "textExtendedBadges": {}
        }
        },
        "orderabilityCommunication": {
        "title": {},
        "subTitle": {},
        "message": {},
        "customIcon": {}
        },
        "differentiatedUi": {
        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        "differentiatedUiMediaDetails": {
        "mediaType": "ADS_MEDIA_ENUM_IMAGE",
        "lottie": {},
        "video": {}
        }
        },
        "reviewsSummary": {},
        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        "restaurantOfferPresentationInfo": {},
        "externalRatings": {
        "aggregatedRating": {
        "rating": "4.6",
        "ratingCount": "3.3K+"
        },
        "source": "GOOGLE",
        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
        },
        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        "analytics": {
        "context": "seo-data-ca89bc1b-9342-4f48-a719-c04d0ee84a7d"
        },
        "cta": {
        "link": "https://www.swiggy.com/city/bangalore/pizza-hut-6th-block-koramangala-rest10576",
        "text": "RESTAURANT_MENU",
        "type": "WEBLINK"
        },
        "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
        },
        {
        "info": {
        "id": "1013619",
        "name": "Chinese Wok",
        "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/12/24/15345730-3e92-4301-8bf8-d3d327d96ce2_1013619.jpg",
        "locality": "Koramangala",
        "areaName": "80 Feet Road",
        "costForTwo": "₹250 for two",
        "cuisines": [
        "Chinese",
        "Asian",
        "Tibetan",
        "Desserts"
        ],
        "avgRating": 4.3,
        "parentId": "61955",
        "avgRatingString": "4.3",
        "totalRatingsString": "7",
        "sla": {
        "deliveryTime": 27,
        "lastMileTravel": 0.5,
        "serviceability": "SERVICEABLE",
        "slaString": "25-30 mins",
        "lastMileTravelString": "0.5 km",
        "iconType": "ICON_TYPE_EMPTY"
        },
        "availability": {
        "nextCloseTime": "2025-01-29 02:00:00",
        "opened": true
        },
        "badges": {},
        "isOpen": true,
        "type": "F",
        "badgesV2": {
        "entityBadges": {
        "imageBased": {},
        "textBased": {},
        "textExtendedBadges": {}
        }
        },
        "aggregatedDiscountInfoV3": {
        "header": "ITEMS",
        "subHeader": "AT ₹129"
        },
        "orderabilityCommunication": {
        "title": {},
        "subTitle": {},
        "message": {},
        "customIcon": {}
        },
        "differentiatedUi": {
        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        "differentiatedUiMediaDetails": {
        "mediaType": "ADS_MEDIA_ENUM_IMAGE",
        "lottie": {},
        "video": {}
        }
        },
        "reviewsSummary": {},
        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        "restaurantOfferPresentationInfo": {},
        "externalRatings": {
        "aggregatedRating": {
        "rating": "--"
        }
        },
        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        "analytics": {
        "context": "seo-data-ca89bc1b-9342-4f48-a719-c04d0ee84a7d"
        },
        "cta": {
        "link": "https://www.swiggy.com/city/bangalore/chinese-wok-koramangala-80-feet-road-rest1013619",
        "text": "RESTAURANT_MENU",
        "type": "WEBLINK"
        },
        "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
        },
        {
        "info": {
        "id": "5934",
        "name": "Burger King",
        "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/6/11/7f76a072-c1bc-4d74-ac56-33e0eea20c1e_5934.JPG",
        "locality": "Koramangala",
        "areaName": "Koramangala",
        "costForTwo": "₹350 for two",
        "cuisines": [
        "Burgers",
        "American"
        ],
        "avgRating": 4.3,
        "parentId": "166",
        "avgRatingString": "4.3",
        "totalRatingsString": "100K+",
        "sla": {
        "deliveryTime": 33,
        "lastMileTravel": 1.4,
        "serviceability": "SERVICEABLE",
        "slaString": "30-35 mins",
        "lastMileTravelString": "1.4 km",
        "iconType": "ICON_TYPE_EMPTY"
        },
        "availability": {
        "nextCloseTime": "2025-01-29 06:55:00",
        "opened": true
        },
        "badges": {
        "imageBadges": [
        {
        "imageId": "bolt/Bolt%20Listing%20badge@3x.png",
        "description": "bolt!"
        },
        {
        "imageId": "Rxawards/_CATEGORY-Burger.png",
        "description": "Delivery!"
        }
        ]
        },
        "isOpen": true,
        "type": "F",
        "badgesV2": {
        "entityBadges": {
        "imageBased": {
        "badgeObject": [
        {
        "attributes": {
        "description": "bolt!",
        "imageId": "bolt/Bolt%20Listing%20badge@3x.png"
        }
        },
        {
        "attributes": {
        "description": "Delivery!",
        "imageId": "Rxawards/_CATEGORY-Burger.png"
        }
        }
        ]
        },
        "textBased": {},
        "textExtendedBadges": {}
        }
        },
        "aggregatedDiscountInfoV3": {
        "header": "60% OFF",
        "subHeader": "UPTO ₹120"
        },
        "orderabilityCommunication": {
        "title": {},
        "subTitle": {},
        "message": {},
        "customIcon": {}
        },
        "differentiatedUi": {
        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        "differentiatedUiMediaDetails": {
        "mediaType": "ADS_MEDIA_ENUM_IMAGE",
        "lottie": {},
        "video": {}
        }
        },
        "reviewsSummary": {},
        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        "restaurantOfferPresentationInfo": {},
        "externalRatings": {
        "aggregatedRating": {
        "rating": "4.2",
        "ratingCount": "4.0K+"
        },
        "source": "GOOGLE",
        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
        },
        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        "analytics": {
        "context": "seo-data-ca89bc1b-9342-4f48-a719-c04d0ee84a7d"
        },
        "cta": {
        "link": "https://www.swiggy.com/city/bangalore/burger-king-koramangala-rest5934",
        "text": "RESTAURANT_MENU",
        "type": "WEBLINK"
        },
        "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
        },
        {
        "info": {
        "id": "676",
        "name": "Chai Point",
        "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/1/22/59f228f3-d214-4865-81fb-6e8b23734e02_676.jpg",
        "locality": "Koramangala",
        "areaName": "Koramangala",
        "costForTwo": "₹150 for two",
        "cuisines": [
        "Bakery",
        "Beverages",
        "Maharashtrian",
        "Snacks",
        "Street Food",
        "South Indian",
        "Punjabi",
        "Chaat",
        "Indian",
        "American"
        ],
        "avgRating": 4.4,
        "parentId": "1607",
        "avgRatingString": "4.4",
        "totalRatingsString": "45K+",
        "sla": {
        "deliveryTime": 37,
        "lastMileTravel": 1.2,
        "serviceability": "SERVICEABLE",
        "slaString": "35-40 mins",
        "lastMileTravelString": "1.2 km",
        "iconType": "ICON_TYPE_EMPTY"
        },
        "availability": {
        "nextCloseTime": "2025-01-28 23:00:00",
        "opened": true
        },
        "badges": {
        "imageBadges": [
        {
        "imageId": "Rxawards/_CATEGORY-Cafe%20&%20Chai.png",
        "description": "Delivery!"
        }
        ]
        },
        "isOpen": true,
        "type": "F",
        "badgesV2": {
        "entityBadges": {
        "imageBased": {
        "badgeObject": [
        {
        "attributes": {
        "description": "Delivery!",
        "imageId": "Rxawards/_CATEGORY-Cafe%20&%20Chai.png"
        }
        }
        ]
        },
        "textBased": {},
        "textExtendedBadges": {}
        }
        },
        "aggregatedDiscountInfoV3": {
        "header": "50% OFF",
        "subHeader": "UPTO ₹100"
        },
        "orderabilityCommunication": {
        "title": {},
        "subTitle": {},
        "message": {},
        "customIcon": {}
        },
        "differentiatedUi": {
        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        "differentiatedUiMediaDetails": {
        "mediaType": "ADS_MEDIA_ENUM_IMAGE",
        "lottie": {},
        "video": {}
        }
        },
        "reviewsSummary": {},
        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        "restaurantOfferPresentationInfo": {},
        "externalRatings": {
        "aggregatedRating": {
        "rating": "4.4",
        "ratingCount": "110"
        },
        "source": "GOOGLE",
        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
        },
        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        "analytics": {
        "context": "seo-data-ca89bc1b-9342-4f48-a719-c04d0ee84a7d"
        },
        "cta": {
        "link": "https://www.swiggy.com/city/bangalore/chai-point-koramangala-rest676",
        "text": "RESTAURANT_MENU",
        "type": "WEBLINK"
        },
        "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
        },
        {
        "info": {
        "id": "275",
        "name": "Mani's Dum Biryani",
        "cloudinaryImageId": "xlr4ngepa5gxkugrsdbs",
        "locality": "Koramangala",
        "areaName": "Koramangala",
        "costForTwo": "₹400 for two",
        "cuisines": [
        "Andhra",
        "Biryani"
        ],
        "avgRating": 4.6,
        "parentId": "623",
        "avgRatingString": "4.6",
        "totalRatingsString": "29K+",
        "sla": {
        "deliveryTime": 34,
        "lastMileTravel": 2.2,
        "serviceability": "SERVICEABLE",
        "slaString": "30-35 mins",
        "lastMileTravelString": "2.2 km",
        "iconType": "ICON_TYPE_EMPTY"
        },
        "availability": {
        "nextCloseTime": "2025-01-28 23:59:00",
        "opened": true
        },
        "badges": {
        "textExtendedBadges": [
        {
        "iconId": "guiltfree/GF_Logo_android_3x",
        "shortDescription": "options available",
        "fontColor": "#7E808C"
        }
        ]
        },
        "isOpen": true,
        "aggregatedDiscountInfoV2": {},
        "type": "F",
        "badgesV2": {
        "entityBadges": {
        "imageBased": {},
        "textBased": {},
        "textExtendedBadges": {
        "badgeObject": [
        {
        "attributes": {
        "description": "",
        "fontColor": "#7E808C",
        "iconId": "guiltfree/GF_Logo_android_3x",
        "shortDescription": "options available"
        }
        }
        ]
        }
        }
        },
        "orderabilityCommunication": {
        "title": {},
        "subTitle": {},
        "message": {},
        "customIcon": {}
        },
        "differentiatedUi": {
        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        "differentiatedUiMediaDetails": {
        "mediaType": "ADS_MEDIA_ENUM_IMAGE",
        "lottie": {},
        "video": {}
        }
        },
        "reviewsSummary": {},
        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        "restaurantOfferPresentationInfo": {},
        "externalRatings": {
        "aggregatedRating": {
        "rating": "4.2",
        "ratingCount": "1.3K+"
        },
        "source": "GOOGLE",
        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
        },
        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        "analytics": {
        "context": "seo-data-ca89bc1b-9342-4f48-a719-c04d0ee84a7d"
        },
        "cta": {
        "link": "https://www.swiggy.com/city/bangalore/manis-dum-biryani-koramangala-rest275",
        "text": "RESTAURANT_MENU",
        "type": "WEBLINK"
        },
        "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
        },
        {
        "info": {
        "id": "186101",
        "name": "The Biryani Life",
        "cloudinaryImageId": "ggd0zsrhjn6bija7olci",
        "locality": "Jakkasandra",
        "areaName": "Hsr Layout 5th Sector",
        "costForTwo": "₹250 for two",
        "cuisines": [
        "Biryani",
        "Mughlai",
        "Lucknowi",
        "Hyderabadi",
        "Kebabs",
        "Desserts",
        "Beverages"
        ],
        "avgRating": 3.9,
        "parentId": "8496",
        "avgRatingString": "3.9",
        "totalRatingsString": "946",
        "sla": {
        "deliveryTime": 34,
        "lastMileTravel": 2.2,
        "serviceability": "SERVICEABLE",
        "slaString": "30-35 mins",
        "lastMileTravelString": "2.2 km",
        "iconType": "ICON_TYPE_EMPTY"
        },
        "availability": {
        "nextCloseTime": "2025-01-28 23:59:00",
        "opened": true
        },
        "badges": {},
        "isOpen": true,
        "type": "F",
        "badgesV2": {
        "entityBadges": {
        "imageBased": {},
        "textBased": {},
        "textExtendedBadges": {}
        }
        },
        "aggregatedDiscountInfoV3": {
        "header": "ITEMS",
        "subHeader": "AT ₹49"
        },
        "orderabilityCommunication": {
        "title": {},
        "subTitle": {},
        "message": {},
        "customIcon": {}
        },
        "differentiatedUi": {
        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        "differentiatedUiMediaDetails": {
        "mediaType": "ADS_MEDIA_ENUM_IMAGE",
        "lottie": {},
        "video": {}
        }
        },
        "reviewsSummary": {},
        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        "restaurantOfferPresentationInfo": {},
        "externalRatings": {
        "aggregatedRating": {
        "rating": "--"
        }
        },
        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        "analytics": {
        "context": "seo-data-ca89bc1b-9342-4f48-a719-c04d0ee84a7d"
        },
        "cta": {
        "link": "https://www.swiggy.com/city/bangalore/the-biryani-life-jakkasandra-hsr-layout-5th-sector-rest186101",
        "text": "RESTAURANT_MENU",
        "type": "WEBLINK"
        },
        "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
        },
        {
        "info": {
        "id": "27811",
        "name": "Natural Ice Cream",
        "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/1/3/da275b37-744c-464f-9c92-2104f4c92e05_27811.JPG",
        "locality": "Koramangala",
        "areaName": "Koramangala",
        "costForTwo": "₹150 for two",
        "cuisines": [
        "Ice Cream",
        "Desserts"
        ],
        "avgRating": 4.8,
        "parentId": "2093",
        "avgRatingString": "4.8",
        "totalRatingsString": "19K+",
        "sla": {
        "deliveryTime": 22,
        "lastMileTravel": 1.4,
        "serviceability": "SERVICEABLE",
        "slaString": "20-25 mins",
        "lastMileTravelString": "1.4 km",
        "iconType": "ICON_TYPE_EMPTY"
        },
        "availability": {
        "nextCloseTime": "2025-01-29 00:00:00",
        "opened": true
        },
        "badges": {
        "imageBadges": [
        {
        "imageId": "bolt/Bolt%20Listing%20badge@3x.png",
        "description": "bolt!"
        },
        {
        "imageId": "Rxawards/_CATEGORY-Ice-creams.png",
        "description": "Delivery!"
        }
        ]
        },
        "isOpen": true,
        "type": "F",
        "badgesV2": {
        "entityBadges": {
        "imageBased": {
        "badgeObject": [
        {
        "attributes": {
        "description": "bolt!",
        "imageId": "bolt/Bolt%20Listing%20badge@3x.png"
        }
        },
        {
        "attributes": {
        "description": "Delivery!",
        "imageId": "Rxawards/_CATEGORY-Ice-creams.png"
        }
        }
        ]
        },
        "textBased": {},
        "textExtendedBadges": {}
        }
        },
        "aggregatedDiscountInfoV3": {
        "header": "20% OFF",
        "subHeader": "UPTO ₹50"
        },
        "orderabilityCommunication": {
        "title": {},
        "subTitle": {},
        "message": {},
        "customIcon": {}
        },
        "differentiatedUi": {
        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        "differentiatedUiMediaDetails": {
        "mediaType": "ADS_MEDIA_ENUM_IMAGE",
        "lottie": {},
        "video": {}
        }
        },
        "reviewsSummary": {},
        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        "restaurantOfferPresentationInfo": {},
        "externalRatings": {
        "aggregatedRating": {
        "rating": "4.5",
        "ratingCount": "4.8K+"
        },
        "source": "GOOGLE",
        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
        },
        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        "analytics": {
        "context": "seo-data-ca89bc1b-9342-4f48-a719-c04d0ee84a7d"
        },
        "cta": {
        "link": "https://www.swiggy.com/city/bangalore/natural-ice-cream-koramangala-rest27811",
        "text": "RESTAURANT_MENU",
        "type": "WEBLINK"
        },
        "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
        },
        {
        "info": {
        "id": "596949",
        "name": "Olio - The Wood Fired Pizzeria",
        "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/1/26/e35f38cf-8697-46f3-9d5d-cf80c6493833_596949.jpg",
        "locality": "Koramangala",
        "areaName": "Koramangala",
        "costForTwo": "₹300 for two",
        "cuisines": [
        "Pizzas",
        "Pastas",
        "Italian",
        "Fast Food",
        "Snacks",
        "Beverages",
        "Desserts"
        ],
        "avgRating": 4.3,
        "parentId": "11633",
        "avgRatingString": "4.3",
        "totalRatingsString": "1.4K+",
        "sla": {
        "deliveryTime": 48,
        "lastMileTravel": 2.3,
        "serviceability": "SERVICEABLE",
        "slaString": "45-50 mins",
        "lastMileTravelString": "2.3 km",
        "iconType": "ICON_TYPE_EMPTY"
        },
        "availability": {
        "nextCloseTime": "2025-01-29 06:00:00",
        "opened": true
        },
        "badges": {
        "imageBadges": [
        {
        "imageId": "newg.png",
        "description": "Gourmet"
        }
        ]
        },
        "isOpen": true,
        "type": "F",
        "badgesV2": {
        "entityBadges": {
        "imageBased": {
        "badgeObject": [
        {
        "attributes": {
        "description": "Gourmet",
        "imageId": "newg.png"
        }
        }
        ]
        },
        "textBased": {},
        "textExtendedBadges": {}
        }
        },
        "aggregatedDiscountInfoV3": {
        "header": "ITEMS",
        "subHeader": "AT ₹99"
        },
        "orderabilityCommunication": {
        "title": {},
        "subTitle": {},
        "message": {},
        "customIcon": {}
        },
        "differentiatedUi": {
        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        "differentiatedUiMediaDetails": {
        "mediaType": "ADS_MEDIA_ENUM_IMAGE",
        "lottie": {},
        "video": {}
        }
        },
        "reviewsSummary": {},
        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        "restaurantOfferPresentationInfo": {},
        "externalRatings": {
        "aggregatedRating": {
        "rating": "4.2",
        "ratingCount": "252"
        },
        "source": "GOOGLE",
        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
        },
        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        "analytics": {
        "context": "seo-data-ca89bc1b-9342-4f48-a719-c04d0ee84a7d"
        },
        "cta": {
        "link": "https://www.swiggy.com/city/bangalore/olio-the-wood-fired-pizzeria-koramangala-rest596949",
        "text": "RESTAURANT_MENU",
        "type": "WEBLINK"
        },
        "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
        }
        ],
        "theme": "SeoRestaurantListingGridWidget"
        }
        }
        }
        }
        },
];

export const IMG_CDN_URL = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

export const RestaurantCard = ({cloudinaryImageId, name, areaName, avgRating}) => {

    return (
        <div className="w-56 p-2 m-3 bg-pink-50 shadow-lg transform transition-transform duration-300 hover:-translate-y-2 rounded-xl">
            <img src={IMG_CDN_URL + cloudinaryImageId} alt="restaurant" />
            <h2 className="font-bold text-xl">{name}</h2>
            <p>{areaName}</p>
            <p>{avgRating}</p>
        </div>
    );
}
 

export const FETCH_RES_URL = "https://www.swiggy.com/dapi/restaurants/list/v5?lat=19.0759837&lng=72.8776559&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING";
